import React from 'react';
const Graduate = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Graduate Programs</h1>
          <div className="w-24 h-1 bg-primary mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto">
            Advance your career with our rigorous graduate programs designed for working professionals and researchers.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Program Card 1 */}
          <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">Master of Science in Data Science</h2>
            <p className="text-gray-600 mb-4">
              Specialized program in big data analytics, machine learning, and data visualization.
            </p>
            <ul className="space-y-2 mb-4">
              <li className="flex items-center">
                <span className="text-primary mr-2">✓</span>
                <span>Duration: 2 years</span>
              </li>
              <li className="flex items-center">
                <span className="text-primary mr-2">✓</span>
                <span>Evening/Weekend Classes</span>
              </li>
              <li className="flex items-center">
                <span className="text-primary mr-2">✓</span>
                <span>Capstone Project</span>
              </li>
            </ul>
            <button className="bg-primary text-white px-6 py-2 rounded-md hover:bg-yellow-600 transition-colors">
              Program Details
            </button>
          </div>

          {/* Program Card 2 */}
          <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">MBA Program</h2>
            <p className="text-gray-600 mb-4">
              Executive MBA designed for experienced professionals seeking leadership roles.
            </p>
            <ul className="space-y-2 mb-4">
              <li className="flex items-center">
                <span className="text-primary mr-2">✓</span>
                <span>Flexible Scheduling</span>
              </li>
              <li className="flex items-center">
                <span className="text-primary mr-2">✓</span>
                <span>Global Immersion</span>
              </li>
              <li className="flex items-center">
                <span className="text-primary mr-2">✓</span>
                <span>Executive Coaching</span>
              </li>
            </ul>
            <button className="bg-primary text-white px-6 py-2 rounded-md hover:bg-yellow-600 transition-colors">
              Program Details
            </button>
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default Graduate;
